




import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import MypageDownloadHistory from '../../components/Membership/Mypage/MypageDownloadHistory.vue'

@Component({
  components: {
    MypageDownloadHistory
  }
})
export default class Mypagedownload extends Vue {
  // MypageDownloadHistoryのダミーページ
  // コンポーネント化した部品をページに生成しないと、非ログイン時にcreatedイベントが実施されるため

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    // ログイン時にコンポーネントを生成する
    return membershipState.isLogin
  }
}
